import React, { useState, useEffect } from 'react'
import { Button, Col, Form, Input, Row, Alert } from 'antd'
import { useNavigate, Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@apollo/client'
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { FORGOTPASSWORD } from './graphql/Mutation'
import { Helpers } from 'pda-components'

const ForgotpasswordForm = ({ recaptchaEnabled }) => {
  const { executeRecaptcha } = useGoogleReCaptcha()
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const navigate = useNavigate()
  const [errorMessage, setErrorMessage] = useState('')
  const { displayError, encryptData, getEnv } = Helpers
  const [forgotPassword, { data: emailData, loading: emailLoading, error: emailError }] = useMutation(FORGOTPASSWORD)
  const onFinish = async (values) => {
    if (values?.email) {
      let recaptchaToken = ''
      if (recaptchaEnabled && executeRecaptcha) {
        try {
          recaptchaToken = await executeRecaptcha('forgotpassword')
        } catch {
          recaptchaToken = ''
        }
      }

      await forgotPassword({
        variables: {
          input: {
            email: values?.email
          },
          recaptchaToken: encryptData(recaptchaToken, getEnv('REACT_APP_SECRET_FE')),
          action: {
            action: 'changepass'
          }
        }
      })
    }
  }

  useEffect(() => {
    if (emailData) {
      form.resetFields()
      setTimeout(() => {
        navigate('/')
      }, 5000)
    }
  }, [emailData])

  useEffect(() => {
    if (emailError) {
      setErrorMessage(emailError.message && emailError.graphQLErrors.length > 0 ? t(displayError(emailError)) : '')
    }
  }, [emailError])

  return (
    <>
      <Row justify="center">
        <Col
          {...{
            xs: 24, //screen < 576px
            md: 11, //screen ≥ 768px
            xl: 8, //screen ≥ 1200px
            xxl: 6 //screen ≥ 1600px
          }}
        >
          <div className="content">
            <div className="title-header">{t('องค์การบริหารไนท์ซาฟารี (องค์การมหาชน)')}</div>
            <div className="title-second">{t('กรุณากรอกอีเมลเพื่อทำการเปลี่ยนรหัสผ่านใหม่')}</div>

            <Row justify="center">
              <Col
                {...{
                  xs: 22,
                  md: 22,
                  lg: 22
                }}
              >
                <Form
                  form={form}
                  name="form-login"
                  layout="vertical"
                  labelCol={{
                    span: 24
                  }}
                  wrapperCol={{
                    span: 24
                  }}
                  onFinish={onFinish}
                  autoComplete="off"
                >
                  <Form.Item
                    label={t('อีเมล')}
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: t('กรุณากรอกอีเมล')
                      }
                    ]}
                  >
                    <Input placeholder={t('Email Address')} />
                  </Form.Item>
                  {emailData && (
                    <Alert
                      type="success"
                      message={
                        <span
                          dangerouslySetInnerHTML={{
                            __html: t(
                              `ระบบได้ส่งลิงค์เปลี่ยนรหัสผ่านไปที่ Email <b>${form.getFieldValue(
                                'email'
                              )}</b> เรียบร้อยแล้ว<br/>กรุณาเช็คอีเมลของคุณที่กล่องขาเข้าหรืออีเมลขยะ(หากไม่พบ)`
                            )
                          }}
                        />
                      }
                      banner
                    />
                  )}
                  {emailError && <Alert type="error" message={errorMessage} banner />}

                  <div className="text-center">
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="btn-login"
                      loading={emailLoading ? true : false}
                    >
                      {t('ยืนยัน')}
                    </Button>

                    <div className="backtologin">
                      <Link to="/login ">
                        <u>{t('กลับไป')}</u>
                      </Link>
                    </div>
                  </div>
                </Form>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
    </>
  )
}

// Wrapper — ครอบ GoogleReCaptchaProvider เมื่อเปิดใช้งานผ่าน env
const Forgotpassword = () => {
  const enableRecaptcha =
    Helpers.getEnv('REACT_APP_RECAPTCHA_ENABLE') === 'true' && !!Helpers.getEnv('REACT_APP_RECAPTCHA_SITE_KEY')
  const recaptchaSiteKey = Helpers.getEnv('REACT_APP_RECAPTCHA_SITE_KEY')

  if (!enableRecaptcha) {
    return <ForgotpasswordForm recaptchaEnabled={false} />
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={recaptchaSiteKey} scriptProps={{ async: true, defer: true, appendTo: 'head' }}>
      <ForgotpasswordForm recaptchaEnabled={true} />
    </GoogleReCaptchaProvider>
  )
}

export default Forgotpassword
